import React from "react";

const FaqItem = ({ id, category, question, answer, isOpen, onToggle }) => {
  return (
    <div className="relative overflow-hidden rounded-2xl border border-[color:var(--border)] bg-white">
      <div className="absolute -top-16 -right-20 h-44 w-44 rounded-full bg-[color:var(--brand-accent)]/10 blur-2xl" />
      <div className="absolute -bottom-20 -left-16 h-52 w-52 rounded-full bg-[color:var(--brand)]/8 blur-2xl" />

      <button
        type="button"
        onClick={onToggle}
        aria-expanded={isOpen}
        aria-controls={`${id}-panel`}
        className="relative w-full text-left px-6 sm:px-7 py-5 flex items-start justify-between gap-6 focus:outline-none"
      >
        <div className="min-w-0">
          <div className="inline-flex items-center gap-2 rounded-full bg-[color:var(--surface)] px-3 py-1 text-xs font-semibold text-[color:var(--brand)] border border-[color:var(--border)]">
            {category}
            <span className="h-1.5 w-1.5 rounded-full bg-[color:var(--brand-accent)]" />
          </div>

          <div className="mt-3 text-[16px] sm:text-lg font-semibold text-[color:var(--navy)]">
            {question}
          </div>
        </div>

        <span
          className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border border-[color:var(--border)] bg-[color:var(--surface)] transition ${
            isOpen ? "rotate-45" : "rotate-0"
          }`}
          aria-hidden="true"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path
              d="M12 5V19M5 12H19"
              stroke="var(--brand)"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </span>
      </button>

      <div
        id={`${id}-panel`}
        role="region"
        aria-label={question}
        className={`relative px-6 sm:px-7 transition-all ${
          isOpen ? "pb-6 max-h-[360px] opacity-100" : "pb-0 max-h-0 opacity-0"
        } overflow-hidden`}
      >
        <p className="text-sm sm:text-[15px] leading-relaxed text-[color:var(--muted)]">
          {answer}
        </p>
      </div>
    </div>
  );
};

export default FaqItem;
